var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "power_settings_new_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_923",
    "data-name": "Trazado 923",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "logout_FILL0_wght300_GRAD0_opsz40",
    d: "M141.415-804.631a1.361,1.361,0,0,1-1-.416,1.361,1.361,0,0,1-.416-1v-12.54a1.361,1.361,0,0,1,.416-1,1.361,1.361,0,0,1,1-.416h5.7a.548.548,0,0,1,.4.164.554.554,0,0,1,.163.407.545.545,0,0,1-.163.4.553.553,0,0,1-.4.161h-5.7a.266.266,0,0,0-.191.087.266.266,0,0,0-.087.191v12.54a.266.266,0,0,0,.087.191.266.266,0,0,0,.191.087h5.7a.548.548,0,0,1,.4.164.554.554,0,0,1,.163.407.545.545,0,0,1-.163.4.553.553,0,0,1-.4.161Zm11.764-7.116h-7.551a.548.548,0,0,1-.4-.164.554.554,0,0,1-.163-.407.544.544,0,0,1,.163-.4.553.553,0,0,1,.4-.161h7.533l-1.806-1.806a.532.532,0,0,1-.163-.391.565.565,0,0,1,.172-.4.543.543,0,0,1,.4-.176.579.579,0,0,1,.41.172l2.687,2.687a.7.7,0,0,1,.212.5.674.674,0,0,1-.212.492l-2.678,2.678a.506.506,0,0,1-.389.165.6.6,0,0,1-.415-.179.568.568,0,0,1-.164-.407.56.56,0,0,1,.174-.4Z",
    transform: "translate(-135.539 824.314)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalir);
export default __webpack_public_path__ + "static/media/salir.a8a0d276f151d126e978a5d869f9e1a4.svg";
export { ForwardRef as ReactComponent };